/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import styles from '_constants/old/_constants/index';
import InputSearch from '../../inputSearch';
import { FormWrapper, SearchButtonGroup, AdvancedCaretButton } from '../filter.style';
import { Button } from '../../styles/button.style';

const {
  BUTTON_STYLES: { SEARCH },
} = styles;

const SearchBlock = ({
  placeholder,
  onChangeInput,
  handleClick,
  onKeyDown,
  isWidth,
  onRemoveSearch,
  searchValue,
  onAdvancedSearch,
  advancedSearchActive,
}) => (
  <FormWrapper>
    <InputSearch
      placeholder={placeholder}
      isColor
      onChange={onChangeInput}
      onKeyDown={onKeyDown}
      isWidth={isWidth}
      onRemoveSearch={onRemoveSearch}
      searchValue={searchValue}
    />
    <SearchButtonGroup>
      <Button id="searchButton" className="searchButton" type="button" buttonType={SEARCH} onClick={handleClick}>
        Search
      </Button>
      {onAdvancedSearch ? (
        <AdvancedCaretButton
          type="button"
          onClick={onAdvancedSearch}
          isActive={advancedSearchActive}
          aria-label="Advanced Search"
          aria-expanded={advancedSearchActive}
          title="Advanced Search"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle cx="16" cy="6" r="2" fill="currentColor" />
            <circle cx="10" cy="12" r="2" fill="currentColor" />
            <circle cx="18" cy="18" r="2" fill="currentColor" />
          </svg>
        </AdvancedCaretButton>
      ) : null}
    </SearchButtonGroup>
  </FormWrapper>
);

export default memo(SearchBlock);
